// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__6C_uc","label":"LabeledBox_label__BBRcc"};